<app-chip 
    [content]="chip.label" 
    [fillPercentage]="chip.fillPercentage"
    [prefixLabel]="this.label"
    [iconNames]="this.icons"
    iconSize="16x16"
    [className]="this.getClassName()"
    labelClassName="!text-xs"
/>